export default "__VITE_ASSET__CI7thsNK__"